import { render, staticRenderFns } from "./serverTableList.vue?vue&type=template&id=4c1e37ed&scoped=true&"
import script from "./serverTableList.vue?vue&type=script&lang=js&"
export * from "./serverTableList.vue?vue&type=script&lang=js&"
import style0 from "./serverTableList.vue?vue&type=style&index=0&id=4c1e37ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1e37ed",
  null
  
)

component.options.__file = "serverTableList.vue"
export default component.exports